var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconAdduser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 30V28C25 26.9391 24.5786 25.9217 23.8284 25.1716C23.0783 24.4214 22.0609 24 21 24H14C12.9391 24 11.9217 24.4214 11.1716 25.1716C10.4214 25.9217 10 26.9391 10 28V30M29 17V23M32 20H26M21.5 16C21.5 18.2091 19.7091 20 17.5 20C15.2909 20 13.5 18.2091 13.5 16C13.5 13.7909 15.2909 12 17.5 12C19.7091 12 21.5 13.7909 21.5 16Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconAdduser);
export default __webpack_public_path__ + "static/media/button-icon-adduser.7a57a6684c8a06339a5c1e3725579816.svg";
export { ForwardRef as ReactComponent };